export default __webpack_public_path__ + "static/abbeyRoad-aee7eb4e1653bef6b1b41e31d7c7f1e9.svg";